import RegisterPricesFlow, {
  type RegisterPricesFlowProps,
} from './RegisterPricesFlow';

type RegisterPricesModalProps = Omit<
  RegisterPricesFlowProps,
  'presentation' | 'initialShipment' | 'onBusyChange' | 'onFormatMapped'
>;

/** Existing Mercado/Evolutivo entry point, backed by the shared flow. */
export default function RegisterPricesModal(props: RegisterPricesModalProps) {
  return <RegisterPricesFlow {...props} />;
}
